import { createAction } from "@reduxjs/toolkit";
import {
	LoginProvider,
	removeTokens,
	SigningProvider,
	useBasePathWithSearchParams,
	useTracking,
} from "@sveabank/cc-common";
import { useEffect } from "react";
import { Outlet, ScrollRestoration, useNavigate, useSearchParams } from "react-router";
import ErrorModal from "../features/error-modal";
import { onboardingApi } from "../services";
import { resetPossibleGuarantors } from "../slices/guarantorSlice";
import { useAppDispatch } from "../store";
import { APPCONFIG } from "../utils/config";
import { convertPreselectedIdToPackageId } from "./layout-helper";

const BaseLayout = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const resetStore = createAction("resetStore");
	const [searchParams, setSearchParams] = useSearchParams();
	const currentPath = useBasePathWithSearchParams(); // use location with search params for tracking purposes

	useEffect(() => {
		const pid = searchParams.get("pid");
		const packageIdParam = searchParams.get("packageId");
		const preSelectedPackageId = pid ?? packageIdParam;
		const packageId = convertPreselectedIdToPackageId(preSelectedPackageId);

		if (!preSelectedPackageId || !packageId) return;

		sessionStorage.setItem("preSelectedPackage", packageId);

		searchParams.delete("packageId");
		searchParams.delete("pid");

		setSearchParams(searchParams);
	}, [searchParams]);

	useTracking({
		ignoredUrls: ["/application"],
		matomoInstance: window.Matomo,
		currentPath,
	});

	return (
		<LoginProvider
			baseUrl={APPCONFIG.ONBOARDING_BASE_URL}
			appVersion={`SveaBankWeb / ${APPCONFIG.RELEASE_NUMBER}`}
			afterLogout={() => {
				dispatch(onboardingApi.util.resetApiState());
				dispatch(resetPossibleGuarantors());
				removeTokens();
				dispatch(resetStore());
				navigate("/");
			}}
		>
			<SigningProvider>
				<Outlet />
				<ErrorModal />
				<ScrollRestoration />
			</SigningProvider>
		</LoginProvider>
	);
};

export default BaseLayout;
